export default __webpack_public_path__ + "static/media/SG-Yellow-0004.3dc252bc.png";